
import React, { useState, useEffect } from "react";
import PopupForm from "../../../Components/PopupForm";
import { useTranslation } from "react-i18next"
import mainUnitObject, {
  checkErrors,
  objectMerge,
  resetErrors,
  resetObject,
} from "../../../Errors/MainUnits/MainUnit";
import { toast } from "react-toastify";
import Cookies from "universal-cookie";
import { useNavigate } from "react-router-dom";
import mainUnitApi from "../../../Network/MainUnit";
import RenderFooter from "./RenderFooter";
import RenderContent from "./RenderContent";
const label = { inputProps: { "aria-label": "Switch demo" } };

const cookies = new Cookies();
const APP_CONSTANTS = {
  API_URL_IMG: `${process.env.REACT_APP_API_URL_image}`,
};


export default function FullUpdateFormContainer(props) {
  const [t] = useTranslation("common");
  const [loading, setLoading] = useState(false);
  const [unit, setUnit] = useState(mainUnitObject);
  const navigate = useNavigate();

  const submit = async () => {
    if (
      cookies.get("active_session") &&
      cookies.get("active_session") == "yes"
    ) {
      try {


        let checkErrorObject = {
          ...unit
        }
        let hasError = false
        let readyToSendObject = {}
        if (unit?.receipt_number?.value  && unit?.receipt_number?.value?.toString()?.trim()?.length>0) {
          let receipt_number = unit?.receipt_number?.value?.toString()?.trim()
          readyToSendObject["receipt_number"] = receipt_number?.replace(/\\|\/|\'/g, "");
        }
        else{
          hasError=true
          checkErrorObject['receipt_number']['error']=true
          checkErrorObject['receipt_number']['message']=[t('GLOBAL.mandatory_field')]
        }
        if (unit?.numbering?.value  && unit?.numbering?.value?.toString()?.trim()?.length>0) {
          let numbering = unit?.numbering?.value?.toString()?.trim()
          readyToSendObject["numbering"] = numbering?.replace(/\\|\/|\'/g, "");
        }
        else{
          hasError=true
          checkErrorObject['numbering']['error']=true
          checkErrorObject['numbering']['message']=[t('GLOBAL.mandatory_field')]
        }

        // if (unit?.plate_number?.value  && unit?.plate_number?.value?.trim()?.length>0) {
        // let plate_number = unit?.plate_number?.value?.trim()
        // readyToSendObject["plate_number"] = plate_number?.replace(/\\|\/|\'/g, "");
        // }
        // else{
        //   hasError=true
        //   checkErrorObject['plate_number']['error']=true
        //   checkErrorObject['plate_number']['message']=[t('GLOBAL.mandatory_field')]
        // }


        if (unit?.plate_letter_id?.value?.id !== null) {
          readyToSendObject["plate_letter_id"] = unit?.plate_letter_id?.value?.id;
        }
        if (unit?.plate_province_id?.value?.id !== null) {
          readyToSendObject["plate_province_id"] = unit?.plate_province_id?.value?.id;
        }
        if (unit?.plate_type_id?.value?.id !== null) {
          readyToSendObject["plate_type_id"] = unit?.plate_type_id?.value?.id;
        }
        if (unit?.main_account_id?.value?.id !== null) {
          readyToSendObject["main_account_id"] = unit?.main_account_id?.value?.id;
        }
        if (unit?.tag_id?.value?.id !== null) {
          readyToSendObject["tag_id"] = unit?.tag_id?.value?.id;
        }
        let is_subscribed = unit?.is_subscribed?.value ? 1 : 0
        readyToSendObject["is_subscribed"] = is_subscribed;

        let is_installed = unit?.is_installed?.value ? 1 : 0
        readyToSendObject["is_installed"] = is_installed;
        let enabled = unit?.enabled?.value ? 1 : 0
        readyToSendObject["enabled"] = enabled;

        if (unit?.installation_date?.value && unit?.installation_date?.value_formated?.length > 0) {

          readyToSendObject["installation_date"] = unit?.installation_date?.value_formated;
        }
        // if (unit?.note?.value  && unit?.note?.value?.trim()?.length>0) {
        let note = unit?.note?.value?.toString()?.trim()
        readyToSendObject["note"] = note?.replace(/\\|\/|\'/g, "");
        // }
        let tid = unit?.tid?.value?.toString()?.trim()
        readyToSendObject["tid"] = tid?.replace(/\\|\/|\'/g, "");
        let epc = unit?.epc?.value?.toString()?.trim()
        readyToSendObject["epc"] = epc?.replace(/\\|\/|\'/g, "");
        let company_name = unit?.company_name?.value?.toString()?.trim()
        readyToSendObject["company_name"] = company_name?.replace(/\\|\/|\'/g, "");
        let driver_name = unit?.driver_name?.value?.toString()?.trim()
        readyToSendObject["driver_name"] = driver_name?.replace(/\\|\/|\'/g, "");
        let plate_number = unit?.plate_number?.value?.toString()?.trim()
        readyToSendObject["plate_number"] = plate_number?.replace(/\\|\/|\'/g, "");
        let plate_letter = unit?.plate_letter?.value?.toString()?.trim()
        readyToSendObject["plate_letter"] = plate_letter?.replace(/\\|\/|\'/g, "");
        let plate_type = unit?.plate_type?.value?.toString()?.trim()
        readyToSendObject["plate_type"] = plate_type?.replace(/\\|\/|\'/g, "");
        let plate_province = unit?.plate_province?.value?.toString()?.trim()
        readyToSendObject["plate_province"] = plate_province?.replace(/\\|\/|\'/g, "");
        let name_and_type = unit?.name_and_type?.value?.toString()?.trim()
        readyToSendObject["name_and_type"] = name_and_type?.replace(/\\|\/|\'/g, "");

        let national_id_number = unit?.national_id_number?.value?.toString()?.trim()
        readyToSendObject["national_id_number"] = national_id_number?.replace(/\\|\/|\'/g, "");
        let car_registration_number = unit?.car_registration_number?.value?.toString()?.trim()
        readyToSendObject["car_registration_number"] = car_registration_number?.replace(/\\|\/|\'/g, "");
        let car_registration_date = unit?.car_registration_date?.value?.toString()?.trim()
        readyToSendObject["car_registration_date"] = car_registration_date?.replace(/\\|\/|\'/g, "");
        let car_registration_to_date = unit?.car_registration_to_date?.value?.toString()?.trim()
        readyToSendObject["car_registration_to_date"] = car_registration_to_date?.replace(/\\|\/|\'/g, "");
        let truck_vin_number = unit?.truck_vin_number?.value?.toString()?.trim()
        readyToSendObject["truck_vin_number"] = truck_vin_number?.replace(/\\|\/|\'/g, "");
        let vin_number = unit?.vin_number?.value?.toString()?.trim()
        readyToSendObject["vin_number"] = vin_number?.replace(/\\|\/|\'/g, "");
        let takeel_number = unit?.takeel_number?.value?.toString()?.trim()
        readyToSendObject["takeel_number"] = takeel_number?.replace(/\\|\/|\'/g, "");
        let takeel_by = unit?.takeel_by?.value?.toString()?.trim()
        readyToSendObject["takeel_by"] = takeel_by?.replace(/\\|\/|\'/g, "");
        
        if (unit?.created_date?.value && unit?.created_date?.value_formated?.length > 0) {

          readyToSendObject["created_date"] = unit?.created_date?.value_formated;
        }
        if (unit?.expire_date?.value && unit?.expire_date?.value_formated?.length > 0) {

          readyToSendObject["expire_date"] = unit?.expire_date?.value_formated;
        }
        if (unit?.car_registration_to_date?.value && unit?.car_registration_to_date?.value_formated?.length > 0) {

          readyToSendObject["car_registration_to_date"] = unit?.car_registration_to_date?.value_formated;
        }
        if (unit?.car_registration_date?.value && unit?.car_registration_date?.value_formated?.length > 0) {

          readyToSendObject["car_registration_date"] = unit?.car_registration_date?.value_formated;
        }

        if (hasError) {
          setUnit({
            ...checkErrorObject
          })
          return
        }



        let params = {
          username: cookies.get("user_name"),
          user_id: cookies.get("user_id"),
          account_name: cookies.get("account_name"),
          account_id: cookies.get("account_id"),
          sid: cookies.get("sid"),
          baseurl: cookies.get("baseUrl"),
          id: cookies.get("id"),
        };

        let result = null;
        if (props?.object && props?.object?.id) {
          readyToSendObject["id"] = props?.object?.id;

          result = await mainUnitApi.editMainUnitTemp({
            data: readyToSendObject,
            params: params,
            id: props?.object?.id,
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          });
        } else {

          result = await mainUnitApi.addMainUnitTemp({
            data: readyToSendObject,
            params: params,
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          });
        }

        if (result?.status && result?.data?.status) {

          setLoading(false);

          toast.success(t("NETWORK_MESSAGES.infoAddedSuccessfully"));
          clearForm();
          props.loadData();
          props.setOpenForm(false);
        } else {

          setLoading(false);

          if (result?.data?.data?.message?.text == "unauthorized to complete") {
            navigate("/redirect");
          }

          else {

            toast.error(result?.data?.data?.message?.text ? result?.data?.data?.message?.text : result?.data?.data?.message)
          }
        }
        setLoading(false);
      } catch (error) {

        setLoading(false);
        toast.error(error.message);
      }
    } else {

      // navigate('/redirect')
    }
  };

  const clearForm = () => {
    setUnit(mainUnitObject)
  };
  useEffect(() => {
    if (!props?.object) {
      clearForm();

    } else {

      setUnit(objectMerge(props?.object))
    }
  }, [props?.openForm, props?.object]);


  return (
    <PopupForm
      open={props.openForm}
      setOpen={props.setOpenForm}
      title={
        props?.object?.id
          ? t("UNITS.update_title")
          : t("UNITS.add_title")
      }
      isFullScreen={false}
      content={
        <RenderContent
          object={unit}
          setObject={(value) => {
            setUnit(value)
          }}
          open={props.openForm}
          setOpen={props.setOpenForm}
          isFullScreen={false}
          
        />
      }
      footer={
        <RenderFooter
          open={props.openForm}
          setOpen={props.setOpenForm}
          submit={submit}
          clearForm={clearForm}
        />
      }
    />
  );
}
